<script>
    import gsap from 'gsap';
    import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
    import {onMount, onDestroy} from "svelte";

    gsap.registerPlugin(DrawSVGPlugin);

    let drawLine;
    let tl = gsap.timeline();
    let svgElement;

    onMount(() => {
        const paths = [...Array.from(svgElement.getElementsByTagName('path')), ...Array.from(svgElement.getElementsByTagName('line')), ...Array.from(svgElement.getElementsByTagName('circle'))];

        tl.fromTo(paths, {
            drawSVG: "100% 100%",
            transformOrigin: 'center center',
        }, {
            drawSVG: "100% 0%",
            stagger: 0.01,
            duration: 0.5,
        }, 0);

        tl.play();
    });

    onDestroy(() => {
        tl.clear();
        tl = null;
    })
</script>

<svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 380 678" bind:this={svgElement}>
    <defs>
        <clipPath id="clip-path">
            <rect id="Rectangle_688" data-name="Rectangle 688" width="242.365" height="229.035" fill="none"/>
        </clipPath>
    </defs>
    <rect id="Rectangle_869" data-name="Rectangle 869" width="380" height="678"/>
    <text id="How_C-suite_executives_choose_their_partners" data-name="How C-suite executives choose
their partners" transform="translate(40 51.446)" fill="#fcd0b1" font-size="24" font-family="Metric-Regular, Metric">
        <tspan x="0" y="0">How C-suite executives choose</tspan>
        <tspan x="0" y="28">their partners</tspan>
    </text>
    <text id="_Innovative_ideas_and_fresh_thinking_Ability_to_support_recommendations_with_data_research_and_evidence"
          data-name="•  Innovative ideas and
    fresh thinking
•  Ability to support
    recommendations with
    data, research and evidence" transform="translate(40 201)" fill="#fff" font-size="24"
          font-family="Metric-Regular, Metric">
        <tspan x="0" y="23" xml:space="preserve">•  Innovative ideas and </tspan>
        <tspan x="0" y="51" xml:space="preserve">    fresh thinking</tspan>
        <tspan x="0" y="79" xml:space="preserve">•  Ability to support </tspan>
        <tspan x="0" y="107" xml:space="preserve">    recommendations with  data,</tspan>
        <tspan x="0" y="135" xml:space="preserve">    research and evidence</tspan>
    </text>
    <text id="CFO" transform="translate(40 101)" fill="#fff" font-size="86" font-family="Metric-Bold, Metric"
          font-weight="700">
        <tspan x="0" y="81">CFO</tspan>
    </text>
    <g id="Group_1349" data-name="Group 1349" transform="translate(48.5 375)">
        <g id="Group_1348" data-name="Group 1348" clip-path="url(#clip-path)">
            <path id="Path_14659" data-name="Path 14659"
                  d="M184.511,228.02a27.555,27.555,0,0,0-23.085-27.186,28.282,28.282,0,0,1-34.373-.167,27.551,27.551,0,0,0-24.291,27.353"
                  fill="none" stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14660" data-name="Path 14660"
                  d="M118.89,174.417a25.521,25.521,0,1,1,25.522,25.522A25.522,25.522,0,0,1,118.89,174.417Z" fill="none"
                  stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14661" data-name="Path 14661" d="M219.7,169.107v58.928H67.575l.25-96.8" fill="none"
                  stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14662" data-name="Path 14662" d="M174.645,37.631H219.7v78.684" fill="none" stroke="#008ed2"
                  stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14663" data-name="Path 14663" d="M67.575,53.433v-15.8H123.4" fill="none" stroke="#008ed2"
                  stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14664" data-name="Path 14664"
                  d="M91.726,130.266l-67.754-.057c-10.541.535-18.877-6.742-21.659-14.9-3.279-9.618-.331-20.047,7.872-25.781,2.777-1.941,6.257-2.99,9.548-4.029,1.4-.442,1.9-.871,2.13-2.249,1.855-11.321,7.414-20.3,17.292-26.294A34.964,34.964,0,0,1,82.434,62.6c.829.853,1.634,1.729,2.562,2.713,7.636-3.341,15.05-3.694,21.941,1,7.714,5.26,10.447,13.026,9.627,22.079-.189,2.088.224,2.936,2.192,3.7a20.847,20.847,0,0,1,11.449,10.5M115.94,130.3l-16.894-.025"
                  fill="none" stroke="#008ed2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14665" data-name="Path 14665"
                  d="M196.467,168.871H177.321M106.146,157.6c-3.359-12.262,1.989-23.929,13.116-28.241,2.04-.79,2.469-1.67,2.273-3.836-.851-9.386,1.983-17.439,9.983-22.894,7.145-4.872,14.832-4.506,22.751-1.041.961-1.02,1.8-1.929,2.656-2.814A36.253,36.253,0,0,1,201.8,92.909c10.243,6.212,16.007,15.526,17.931,27.264.234,1.429.759,1.874,2.208,2.332,3.413,1.078,7.021,2.166,9.9,4.179,8.506,5.945,11.562,16.759,8.163,26.732-2.886,8.463-11.529,16.009-22.459,15.455H203.224"
                  fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14666" data-name="Path 14666"
                  d="M138.057,77.8V75.566a24,24,0,0,0-7.2-16.86,25.463,25.463,0,0,1,15.218-43.191,28.665,28.665,0,0,1,2.971-.158,25.177,25.177,0,0,1,16.964,6.5,25.462,25.462,0,0,1,1.625,36.376,27.312,27.312,0,0,0-7.67,18.572v1.45a3.431,3.431,0,0,1-3.424,3.425H141.5c-1.992.017-3.442-1.625-3.442-3.879Z"
                  fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14667" data-name="Path 14667" d="M150.192,23.258a21.842,21.842,0,0,0-15.935,9.889"
                  fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path id="Path_14668" data-name="Path 14668"
                  d="M140.288,81.687v2.491a3.294,3.294,0,0,0,3.294,3.294H154.9a3.294,3.294,0,0,0,3.294-3.294V81.366"
                  fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <line id="Line_7868" data-name="Line 7868" x1="7.994" y2="4.615" transform="translate(173.693 20.154)"
                  fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <line id="Line_7869" data-name="Line 7869" x1="4.615" y2="7.994" transform="translate(162.577 6.005)"
                  fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <line id="Line_7870" data-name="Line 7870" y2="9.231" transform="translate(147.565 0.999)" fill="none"
                  stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <line id="Line_7871" data-name="Line 7871" x2="4.615" y2="7.994" transform="translate(128.065 6.478)"
                  fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <line id="Line_7872" data-name="Line 7872" x2="7.994" y2="4.615" transform="translate(113.916 20.973)"
                  fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        </g>
    </g>
</svg>
